// 用户

import UltMeta, { Meta } from "./UltMeta/index";

class SysUserType extends UltMeta {
    /** 采购方- 客户端 */
    OUTER = new Meta(1, "外部用户");
    /** 销售方 供应链端 */
    INNER = new Meta(2, "内部用户");
}

export const SYS_USER_TYPE = new SysUserType();

// 供应链，区分是SAAS,独立部署
class SystemType extends UltMeta {
    /** SAAS */
    SAAS = new Meta(1, "SAAS");
    /** 独立部署 */
    INDEPENDENT = new Meta(2, "独立部署");
}

export const SYSTEM_TYPE = new SystemType();
